export default __webpack_public_path__ + "static/media/m_engineering_card25_2.f5d276c8.png";